export default "__VITE_ASSET__$T__bkEc__"